import React, { lazy, Suspense } from "react";
import { observer } from "mobx-react";
import { injectMainStore } from "@cuba-platform/react";
import { Spin } from "@shared/antd/spin";
import { ROUTES } from "../../mobile-routes";

const IncomingFeedbackQuestionsPageLazy = lazy(() => import("@pages/PortalFeedbackQuestions/incoming-feedback-questions-page"));

@injectMainStore
@observer
export class PortalIncomingFeedbackQuestionsManagement extends React.Component {
  static PATH = ROUTES.portalIncomingFeedbackQuestions.desktop;
  static NEW_SUBPATH = "new";

  render() {
    return (
      <>
        <Suspense fallback={<Spin spinning={true} />}>
          <IncomingFeedbackQuestionsPageLazy />
        </Suspense>
      </>
    );
  }
}
